import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import {
  buyerDeprAndAmortScheduleAtom,
  buyerDeprAndAmortScheduleDealExpensesAtom,
} from "@/financeModels/owasco/general";
import { toNumberOrNull } from "@/utils/math";
import { Stack } from "@mantine/core";
import { useAtom } from "jotai";
import { TbFileInvoice } from "react-icons/tb";
import { InputYears } from "../../Sidebar/InputYears";

const Panel = () => {
  const [deprAmortYears, setDeprAmortYears] = useAtom(
    buyerDeprAndAmortScheduleAtom,
  );

  const [dealExpensesYears, setdealExpensesYears] = useAtom(
    buyerDeprAndAmortScheduleDealExpensesAtom,
  );

  return (
    <Stack gap={4}>
      <InputYears
        labelWidth={190}
        value={toNumberOrNull(deprAmortYears) || ""}
        onChange={(value) => setDeprAmortYears(toNumberOrNull(value))}
        label={
          <LabelExplainer
            label="D&A Schedule - Goodwill"
            explanation={
              <Doc path="@/docs/pages/model/sidebar/opAssAmortOfGoodwill.mdx" />
            }
          />
        }
      />

      <InputYears
        labelWidth={190}
        value={toNumberOrNull(dealExpensesYears) || ""}
        onChange={(value) => setdealExpensesYears(toNumberOrNull(value))}
        label={
          <LabelExplainer
            label="D&A Schedule - Deal Exp."
            explanation={
              <Doc path="@/docs/pages/model/sidebar/opAssAmortOfDealExpenses.mdx" />
            }
          />
        }
      />
    </Stack>
  );
};

export const ModuleDepreciationAmortization = {
  key: "Depreciation & Amortization",
  icon: <TbFileInvoice />,
  control: "Depreciation & Amortization",
  panel: <Panel />,
};
